import * as AbWebResources from "abweb/generated/locale/AbWebResources";
export class IllegalStateError extends Error {
  constructor(reason) {
    let message = AbWebResources.error_illegalStateError(reason);
    super(message);
  }
}
//# sourceMappingURL=IllegalStateError.js.map
